export type Screen = 'mobile' | 'tablet' | 'desktop' | 'widescreen';

export namespace variables {
  // export const columnGap = space.values.toRem.md;

  export const COLUMNS_CLASS_NAME = 'joy-columns';
  export const COLUMN_CLASS_NAME = `${COLUMNS_CLASS_NAME}__column`;

  export const breakpointsByScreen: { [screen in Screen]: number } = {
    mobile: 640,
    tablet: 641,
    // 960 and 1680 were chosen because they are divisibly by both 12 and 16
    desktop: 960,
    widescreen: 1680
  };
}
